import { Component, ViewChild } from '@angular/core';

import { ThfDynamicFormComponent, ThfModalAction, ThfModalComponent } from '@totvs/thf-ui';

import { ThfAdvancedFilterBaseComponent } from './thf-advanced-filter-base.component';

/**
 * @docsPrivate
 *
 * @docsExtends ThfAdvancedFilterBaseComponent
 *
 * @examplePrivate
 *
 * <example-private name="thf-advanced-filter" title="Totvs Busca AvanÃ§ada">
 *   <file name="sample-thf-advanced-filter.component.html"> </file>
 *   <file name="sample-thf-advanced-filter.component.ts"> </file>
 * </example-private>
 */
@Component({
  selector: 'thf-advanced-filter',
  templateUrl: './thf-advanced-filter.component.html'
})
export class ThfAdvancedFilterComponent extends ThfAdvancedFilterBaseComponent {

  filter = {};

  @ViewChild(ThfModalComponent, { static: true }) thfModal: ThfModalComponent;

  @ViewChild(ThfDynamicFormComponent, { static: true }) thfDynamicForm: ThfDynamicFormComponent;

  primaryAction: ThfModalAction = {
    action: () => {
      const models = this.getValuesFromForm();

      this.searchEvent.emit(models);
      this.thfModal.close();
    },
    label: this.literals.primaryActionLabel
  };

  secondaryAction: ThfModalAction = {
    action: () => {
      this.thfModal.close();
    },
    label: this.literals.secondaryActionLabel
  };

  // Retorna os models dos campos preenchidos
  getValuesFromForm() {
    Object.keys(this.filter).forEach(property => {
      if (this.filter[property] === undefined || this.filter[property] === '') {
        delete this.filter[property];
      }
    });

    return this.filter;
  }

  open() {
    this.filter = {};
    this.thfModal.open();
  }

}
